import React from "react";
import { useGlobalSelectionStore } from "@/store/useGlobalSelectionStore";

export const CursorModeIndicator: React.FC = () => {
  const activeCursorMode = useGlobalSelectionStore(
    (state) => state.activeCursorMode
  );
  const getCursorModeMessage = useGlobalSelectionStore(
    (state) => state.getCursorModeMessage
  );

  const message = getCursorModeMessage();

  if (!activeCursorMode || !message) return null;

  return (
    <div className="absolute top-1 left-1 z-20 animate-fade-in pointer-events-auto">
      <div className="bg-green-500 text-white px-6 py-3 rounded-lg shadow-lg flex items-center gap-3">
        {/* Icon based on mode */}
        <div className="flex items-center justify-center w-6 h-6">
          {activeCursorMode === "node-creation" && (
            <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
              <circle cx="10" cy="10" r="4" />
            </svg>
          )}
          {activeCursorMode === "beam-creation" && (
            <svg
              className="w-5 h-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 20 20"
            >
              <line x1="2" y1="10" x2="18" y2="10" strokeWidth="2" />
            </svg>
          )}
          {(activeCursorMode === "support-apply-click" ||
            activeCursorMode === "load-apply-click" ||
            activeCursorMode === "property-apply-click" ||
            activeCursorMode === "loadcase-apply-click") && (
            <svg
              className="w-5 h-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 20 20"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M15 15l-2 5L9 9l11 4-5 2zm0 0l5 5M7.188 2.239l.777 2.897M5.136 7.965l-2.898-.777M13.95 4.05l-2.122 2.122m-5.657 5.656l-2.12 2.122"
              />
            </svg>
          )}
          {activeCursorMode === "prep-mode" && (
            <svg
              className="w-5 h-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 20 20"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
              />
            </svg>
          )}

          {activeCursorMode === "select-nodes" && (
            <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
              <circle cx="6" cy="6" r="2" />
              <circle cx="14" cy="6" r="2" />
              <circle cx="6" cy="14" r="2" />
              <circle cx="14" cy="14" r="2" />
            </svg>
          )}

          {activeCursorMode === "divide-beam" && (
            <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
              <line
                x1="4"
                y1="12"
                x2="20"
                y2="12"
                stroke="currentColor"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <circle cx="4" cy="12" r="2" fill="currentColor" />
              <circle cx="20" cy="12" r="2" fill="currentColor" />
              <circle
                cx="12"
                cy="12"
                r="3"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              />
              <circle cx="12" cy="12" r="1.5" fill="currentColor" />
              <line
                x1="10"
                y1="10"
                x2="14"
                y2="14"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
              />
              <line
                x1="10"
                y1="14"
                x2="14"
                y2="10"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
              />
            </svg>
          )}
          {activeCursorMode === "select-beams" && (
            <svg
              className="w-5 h-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 20 20"
            >
              <line x1="2" y1="6" x2="18" y2="6" strokeWidth="2" />
              <line x1="2" y1="14" x2="18" y2="14" strokeWidth="2" />
            </svg>
          )}
          {activeCursorMode === "select-all" && (
            <svg
              className="w-5 h-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 20 20"
            >
              <rect x="3" y="3" width="14" height="14" strokeWidth="2" rx="2" />
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M7 10l2 2 4-4"
              />
            </svg>
          )}
        </div>

        {/* Message */}
        <span className="font-medium text-sm">{message}</span>

        {/* Close button */}
        <button
          onClick={() => useGlobalSelectionStore.getState().clearCursorMode()}
          className="ml-2 hover:bg-green-600 rounded p-1 transition-colors"
          aria-label="Cancel mode"
        >
          <svg
            className="w-4 h-4"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 20 20"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      </div>
    </div>
  );
};
